import React, { useContext, useEffect, useState, useCallback } from "react";
import { Box } from "@mui/material";
import { TOContext } from "context/TContext";
import { useApplyPaymentCardMutation } from "api";
import { useLocation } from "react-router-dom";
// import {PAYMENT_WITH_CARD} from "hooks/useCreditCard";
import { usePaymentContext } from "context/TPaymentContext";
import GoogleOrApplePaySkeleton from "components/Skeleton/GoogleOrApplePaySkeleton";
import { getForwardPaymentIntentId } from "helpers/getForwardPaymentIntentId";

const ApplePayButtonForward = ({
  handleCardError,
  applePayPaymentRequest,
  userInfo,
}) => {
  const {
    paymentIntent,
    isForwardApplePaySupported,
    setForwardPaymentMethod,
    setIsApplePayOrGooglePay,
    setConfirmOrderLoading,
    isLoadingForWard,
    forwardPaymentIntentId,
  } = usePaymentContext();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const oId = searchParams.get("oId");

  const [applyPaymentCard] = useApplyPaymentCardMutation();
  const [buttonLoading, setButtonLoading] = useState(false);
  const { setIsPaid, charges } = useContext(TOContext);

  const handleSubmitGooglePay = useCallback(
    async (token, paymentData) => {
      try {
        const paymentIntentId =
          getForwardPaymentIntentId(oId) || forwardPaymentIntentId;

        localStorage.setItem(`${oId}-balanceDue`, charges?.balanceDue);
        const requestData = {
          orderId: oId,
          forwardPaymentMethod: token,
          forwardPaymentIntentId: paymentIntentId,
          tipInfo: {
            kitchen: Number(charges?.tipInfo?.kitchen) || 0,
            driver: Number(charges?.tipInfo?.driver) || 0,
          },
        };
        const response = await applyPaymentCard({ requestData });
        if (response?.error?.data) {
          setIsPaid(false);
        } else {
          setIsPaid(true);
        }
      } catch (error) {
        // This will catch errors from applyPayment or any other errors in the try block
        setIsPaid(false);
        console.error("Failed to process payment or preparation error:", error);
      }
    },
    [
      oId,
      charges?.balanceDue,
      charges?.tipInfo?.kitchen,
      charges?.tipInfo?.driver,
      forwardPaymentIntentId,
      applyPaymentCard,
      setIsPaid,
    ],
  );

  useEffect(() => {
    const mountApplePay = async () => {
      const windowWithCardEntry = window;
      const applePayButtonContainer = document.getElementById("payment-button");
      if (applePayButtonContainer?.childNodes?.length === 0) {
        setButtonLoading(true);
      }
      if (windowWithCardEntry.Forward && isForwardApplePaySupported) {
        const applePayButton =
          await windowWithCardEntry?.Forward.createApplePayButton({
            apiKey: process.env.REACT_APP_FORWARD_KEY,
            clientSecret: paymentIntent,
          });
        if (typeof document !== "undefined") {
          const applePayButtonContainer =
            document.getElementById("payment-button");
          setButtonLoading(false);
          if (applePayButtonContainer) {
            applePayButtonContainer.innerHTML = "";
          }
        }

        const unmountApplePayButton = applePayButton.mount("#payment-button", {
          onSuccess: async (data) => {
            setForwardPaymentMethod(data?.token);
            handleCardError(false);
            console.log(data, "data>>>>SUCCESSES");
            setIsApplePayOrGooglePay(true);
            setTimeout(() => {
              handleSubmitGooglePay(data?.token, data);
            }, 150);
          },
          onError: () => {
            handleCardError(true);
            setIsApplePayOrGooglePay(false);
          },
          onCancel: () => {
            setIsApplePayOrGooglePay(false);
            setConfirmOrderLoading(false);
            console.debug("User closed apple Pay pop-up window");
          },
          applePayButtonOptions: {
            buttonType: "checkout",
            width: 200,
            zIndex: 9,
            buttonSizeMode: "fill",
            buttonRadius: 24,
          },
          applePayPaymentRequest: applePayPaymentRequest,
        });
        return () => unmountApplePayButton();
      }
    };
    try {
      mountApplePay();
    } catch (error) {
      console.error("Error mounting Apple Pay button:", error);
    }
  }, [
    paymentIntent,
    applePayPaymentRequest,
    isForwardApplePaySupported,
    handleCardError,
    setConfirmOrderLoading,
    setForwardPaymentMethod,
    setIsApplePayOrGooglePay,
    handleSubmitGooglePay,
  ]);

  return (
    <Box
      sx={{
        position: "relative",
      }}
    >
      <Box>
        {(isLoadingForWard || buttonLoading) && <GoogleOrApplePaySkeleton />}
        <Box
          id="payment-button"
          sx={{
            zIndex: 9,
            flex: 1,
            overflow: "hidden",
            width: "100%",
            height: "100%",
          }}
        />
      </Box>
    </Box>
  );
};

export default ApplePayButtonForward;
